module.exports = __webpack_public_path__ + "img/legend-of-zelda.cdd99c3f.jpg";